module.exports = __webpack_public_path__ + "img/btn_banner_demo.c74abd53.png";